// Importing necessary dependencies
import React, { useState, useEffect } from 'react'; // React hooks for state and effects
import axios from 'axios'; // Axios for making HTTP requests

// AppointmentLabel component that manages appointment dates for a given case
const AppointmentLabel = ({ caseId }) => {
  // State to hold the selected appointment date and loading status
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // useEffect hook to fetch the appointment date from the backend when the component is mounted
  useEffect(() => {
    // Function to fetch appointment date from the backend
    const fetchAppointmentDate = async () => {
      try {
        // Sending GET request to fetch appointment date based on caseId
        const response = await axios.get(`https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}`);
        
        // Set the fetched appointment date or an empty string if not available
        setSelectedAppointmentDate(response.data.appointment || '');
      } catch (error) {
        console.error('❌ Error fetching appointment date:', error);
      } finally {
        // Set loading state to false after fetching data
        setIsLoading(false);
      }
    };

    // Call the fetchAppointmentDate function
    fetchAppointmentDate();
  }, [caseId]); // Dependency array - this effect runs when the caseId changes

  // Handle change of the appointment date input field
  const handleDateChange = async (e) => {
    const newDate = e.target.value;
    setSelectedAppointmentDate(newDate); // Update the selected date in the state

    try {
      // Sending PUT request to update the appointment date on the backend
      await axios.put(`https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}`, { appointment: newDate });
      
    } catch (error) {
      console.error('❌ Error updating appointment date:', error);
    }
  };

  return (
    <div>
      {/* Display label for the appointment */}
      <p style={{ fontWeight: 'bold' }}>Patient Appointment:</p>
      
      <div style={{ display: "flex" }}>
        {/* Input field for selecting the appointment date */}
        <input
          type="date" // Date input type
          value={isLoading ? '' : selectedAppointmentDate} // If loading, show empty, else show the selected date
          onChange={handleDateChange} // Call handleDateChange on change of input
          className="form-control me-2" // Bootstrap classes for styling
          style={{
            padding: '7px 14px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            width: 'auto',
          }}
          disabled={isLoading} // Disable input field if data is still loading
        />
      </div>
    </div>
  );
};

export default AppointmentLabel;
